import functions from "./functions.js";
import tplLoader from "./tpl-loader.js";
import tplMapInfo from "./tpl-map-info.js";
import pagination from "./pagination.js";
import MarkerClusterer from "@google/markerclustererplus";
import noUiSlider from 'nouislider';


const list = {
    // references
    $form: null,
    $formContainer: null,
    form: null,
    $moreFiltersBtns: null,
    $moreFiltersBtnsIcons: null,
    $filtersForm: null,
    moreFilters: false,
    $moreFiltersContainer: null,
    $shownItems: null,
    $listWrap: null,
    $total: null,
    $body: {},
    $list: null,
    list: null,
    $map: null,
    map: null,
    infoWindow: null,
    infoWindowOpen: null,
    cluster: null,
    lastEvent: null,
    // form params
    params: {},
    defaults: {
        dateFrom: '',
        dateTo: '',
        destination: '',
        objectTypeId: '',
        guests: '',
        personsInObject: '',
        sortBy: 0,
        _page: 1,
        rooms: '',
        bathrooms: '',
        themeId: '',
        tagCategoryId: '',
        distanceBeach: '',
        distanceCenter: '',
        publicId: '',
        parking: '',
        pool: '',
        pets: '',
        grill: '',
        ac: '',
        sattv: '',
        internet: '',
        disabledPersons: '',
        washingMachine: '',
        coordinates: '',
        template: '',
        language: functions.getLang()
    },
    mainFields: ['dateFrom', 'dateTo', 'destination', 'ms', 'persons', 'guests', 'dates', 'personsInObject', 'sortBy', '_page'],
    notCountabledFields: ['dates', 'destination', 'guests', 'ms', 'coordinates', 'dateFrom', 'sortBy', '_page', 'perPage', 'language'],
    // set by hash change to prevent change event on form fields
    pauseChange: false,
    pageOnlyChange: false,
    // hashchange and form fields change are delayed
    changeTimeout: null,
    loading: false,
    // ajax load id
    loadId: 0,
    total: null,
    // for non ajax form to reset page on normal submit
    paginated: false,
    disabledFields: {},
    locations: null,

    // methods
    // get URL params and merge with defaults
    getParams() {
        list.params = $.extend({}, list.defaults, functions.getSearchParamsFromCookie() ,functions.getUrlData(list.$body.length));
        list.setFiltersCount();
    },
    // on form fields change set URL which will trigger load mode
    onChange(e) {

        if (!list.$body.length) {
            return;
        }
        clearTimeout(list.changeTimeout);
        if (list.pauseChange) {
            return;
        }

        if ( e && e.target.name == 'dates' ) {
            let val = e.target.value.split(' - ');
            
            // if (val.length == 2)

            if ( val.length != 2 && val[0] != '') {
                return;
            }  
            
        }
        if ( e && e.target.name == 'ms') {
            
            if(list.params.ms == '' && list.params.coordinates != '') {
                list.params.coordinates = ''; 
            }
        }

        list.changeTimeout = setTimeout(() => {
            let params = list.getFormData();
            if (params.dates) delete params.dates;
            functions.setUrlData(params, list.$body.length, false, list.defaults);
            functions.setSearchParamsInCookie(params);
        }, 300);
    },
    splitDates(params) {
        if(params.dates)
        {
            let val = params.dates.split(' - ');
            params.dateFrom  = val[0];
            params.dateTo    = val[1];
            // params.dates = null;
        }
        else
        {
            return;
        }
        
    },
    getFormData() {

        let formData = $.extend(
            functions.isMobile() && list.$body.length ? functions.getFormData(list.$mobileForm) : functions.getFormData(list.$form),
            list.$filtersForm ? functions.getFormData(list.$filtersForm) : {},
            {
                _page: list.paginated ? list.params._page : 1,
                sortBy: list.paginated ? list.params.sortBy : 0
            }
        );
        list.paginated = false;
        if (formData.ms && formData.coordinates) delete formData.coordinates;
        if (formData.dates) list.splitDates(formData);
        if (formData.distanceBeach && formData.distanceBeach == 0) delete formData.distanceBeach;
        if (formData.distanceCenter && formData.distanceCenter == 0) delete formData.distanceCenter;

        $.map(formData, (val, key) => {
            if (list.defaults[key] == val || !val) {
                delete formData[key];
            }
        });
        return formData;
    },
    setFormData(formData = null)
    {
        let params = $.extend({}, list.params);
        if (params.dateFrom && params.dateTo) params.dates = params.dateFrom + ' - ' + params.dateTo;

        list.$form.each((index, elem) => {
            functions.setFormData(elem, formData || params);
        })
        if (list.$mobileForm && list.$mobileForm.length) functions.setFormData(list.mobileForm, formData || params);
        if ( list.$filtersForm && list.$filtersForm.length ) functions.setFormData(list.$filtersForm[0], formData || params);

    },
    init() {
        list.$form = $('.form-search');
        if (!list.$form.length) {
            return;
        }

        list.$body = $('.body-listing');
        if (! list.$body.length) list.$body = $('.body-listing-compare');

        list.$formContainer = $('.form-search-container');
        list.form = list.$form[0];

         function rangeSliderValueFunc($value, prefix, suffix, values) {
            let value = (suffix == '€' ? functions.formatMoney(+values[0], 0, ',') + ' ' : +values[0]) + suffix;
            if ( values[1] !== undefined ) {
                value += ' - ' + ((suffix == '€' ? functions.formatMoney(+values[1], 0, ',')+ ' ' : +values[1]) + suffix);
            }
            $value.html($value && value[0] > 0 ? (prefix + value) : '');
        }
    
        const customrangeSliderValueFuncs = {
            rangeYearValue: ($value, values, config) => {
                let min = +values[0];
                if ( min == config.range.min ) {
                    min = '< ' + min;
                }
                $value.html(min + ' - ' + +values[1]);
            }
        };

        list.$filtersForm = $('.filters-form');
        list.$moreFiltersBtns = $('.more-filters');
        list.$moreFiltersBtnsIcons = list.$moreFiltersBtns.find('i');
        list.$filtersCount = $('.filters-count');
        list.$moreFiltersContainer = $('.more-filters-wrapper');
        list.$listWrap = $('.list-wrap');

        list.$shownItems = $('.list-shown-items');
        list.$total = $('.list-total');

        list.$mobileForm = $('.main-fields-mobile-form');
        if ( list.$mobileForm && list.$mobileForm.length ) list.mobileForm = list.$mobileForm[0]

        list.defaultParams = list.$form.attr('data-params') ? JSON.parse(list.$form.attr('data-params')) : [];

        $.map(list.defaultParams, (value, key) => {
            list.params[key] = value;
            list.defaults[key] = value;
        });

        list.setDisabledFields();
        list.getParams();

        list.setFormData();
        
        list.$body.length && list.find();
        if(list.$body.length) {
            let doFind = $.extend({}, functions.getSearchParamsFromCookie(), functions.getUrlData(list.$body.length));
            if (Object.values(doFind).filter(n => n).length) {
                list.find();
            } else if (list.params.template != 'compare') {
                // let ajaxId = ++list.loadId;
                // list.mapFind(ajaxId);
            }
        }

        // register main form fields changes
        // list.$form.on(
        //     'change',
        //     // bit slower delegated selector but live changes are only applied on desktop listing form
        //     '.form-search-header:hidden + .form-row .main-field' +
        //     // sortBy
        //     ', .form-search-container + .container .main-field',
        //     list.onChange
        // );

        list.$body.length && list.params.template != 'compare' &&list.$form.on('change', list.onChange)


       $('.range-slider').each((i, elem) => {
            const $elem = $(elem);
            const $input = $(elem).find('input');
            const min = +$elem.attr('data-min') || 0;
            const max = +$elem.attr('data-max') || 1000;
            const name = $elem.attr('data-name') || '';
            const step = +$elem.attr('data-step') || 1;
            const suffix = $elem.attr('data-value-suffix') || '';
            const prefix =  $elem.attr('data-value-prefix') || '';
            const valueFunc = $elem.attr('data-value-func') || null;
            const start = list.params[name] || 0;
            if (!name) return;

            const config = {
                start: [start],
                connect: [true, false],
                step: step,
                range: {
                    'min': [min],
                    'max': [max]
                }
            };
            // end && (config.start[1] = end);
            noUiSlider.create(elem, config);
            $input[0].noUiSlider = elem.noUiSlider;
    
            const $value = $($elem.parent()).find('.range-slider-value');
    
            elem.noUiSlider.on('update', values => {
                if ( valueFunc && customrangeSliderValueFuncs[valueFunc] ) {
                    customrangeSliderValueFuncs[valueFunc]($value, values, config);
                } else {
                    rangeSliderValueFunc($value, prefix, suffix, values);
                }
            });
            elem.noUiSlider.on('change', () => {
                let value = elem.noUiSlider.get();
                value = $.isArray(value) ? value : [value];
                value = value.map(v => +v);
                value = value.join(',');
                //console.log(value);
                $input.val(value).trigger('change');
            });
        });

        $('.clear-param').on('click', e => {
            let $elem = $(e.currentTarget);
            let name = $elem.attr('data-clear');
            list.params[name] = list.defaults[name];
            if (name == 'dates') {
                functions.setSearchParamsInCookie({dateFrom: '', dateTo: ''});
            }
            else {
                name != 'ms' && functions.setSearchParamsInCookie({[name]: list.defaults[name]});
            }
            list.setFormData({[name]: list.defaults[name]});
        })

        if ( list.$body ) {
            list.$body.on('click', '.show-on-map', e => {

                e.preventDefault();
                const $this = $(e.currentTarget);
                const objectId = +$this.attr('data-publicId');
                const marker = list.markers.filter(marker => {

                    return marker.objectId == objectId
                })[0];
                list.infoWindowOpen = true;
                list.suppressMapEvents = true;
                list.map.setCenter(marker.position);
                list.map.setZoom(15);
                google.maps.event.trigger(marker, 'click');
            });
        }


        // register form submit
        list.$form.on('submit', e => {
            e.preventDefault();
            if (list.$body.length) {
                list.onChange();
                list.toggleMobileForm(false);
                
            } else {
                $('.submit-loader-wrap').removeClass('d-none');
                // non ajax form
                let params = list.getFormData();
                if (params.dates) list.splitDates(params), delete params.dates;

                let data = $.param(params),
                    toHash = list.$form.hasClass('form-hash');

                functions.setSearchParamsInCookie(list.getFormData());

                let href = location.protocol + '//' + location.host + list.$form.attr('action');
                if (data) {
                    href += (href.indexOf('?') === -1 ? (toHash ? '#' : '?') : '&');
                }
                href += data;
                list.setLoadingMode();
                // list.toggleFilters(false);
                location.href = href;
            }
        });

        // register form submit
        list.$filtersForm.on('submit', e => {
            
            e.preventDefault();
            if (list.$body.length) {
                list.onChange();
                list.toggleMobileForm(false);
            } else {
                return;
                // non ajax form
                let data = $.param(list.getFormData()),
                    toHash = list.$form.hasClass('form-hash');

                functions.setSearchParamsInCookie(list.getFormData());

                let href = location.protocol + '//' + location.host + list.$form.attr('action');
                if (data) {
                    href += (href.indexOf('?') === -1 ? (toHash ? '#' : '?') : '&');
                }
                href += data;
                list.setLoadingMode();
                // list.toggleFilters(false);
                location.href = href;
            }
        });

        // register hashchange which trigger load
        $(window).on('hashchange', () => {
            list.pauseChange = true;
            clearTimeout(list.changeTimeout);
            list.changeTimeout = setTimeout(() => {
                list.getParams();
                
                let params = $.extend({}, list.params);
                if (params.dateFrom && params.dateTo) params.dates = params.dateFrom + ' - ' + params.dateTo;

                functions.setFormData(list.form, params);
                list.find();
                list.pauseChange = false;
            }, 100);
        });

        // register sort
        let $dropdown = $(".dropdown-sort-by");
        $dropdown.find('.dropdown-item').on('click', function (e) {
            e.preventDefault();
            list.params._page = 1;
            list.params.sortBy = $(e.currentTarget).attr('data-href');
            if ( list.$body.length ) {
                console.log(list.params, list.defaults);
                functions.setUrlData(list.params, true, false, list.defaults);
            } else {
                list.paginated = true;
                list.$form.submit();
            }
        });

        if (list.params.sortBy) {
            let text = $dropdown.find(".dropdown-item[data-href='"+list.params.sortBy+"']").html();
            $dropdown.find(".btn .sort-text").html(text);
        }

        

        $('#fullscreen').on('click tap vclick', function() {
            $('.list').addClass('hide-list-list');
            $('.map-and-filters').addClass('d-none');
            $('.map-close-btn').removeClass('d-none');
            $('.list-map').addClass('show-map-list');
            $('.list-wrap').addClass('list-wrap-overflow');
        });
        
        $('#close-map').on('click tap vclick', function() {
            $('.list').removeClass('hide-list-list');
            $('.map-and-filters').removeClass('d-none');
            $('.map-close-btn').addClass('d-none');
            $('.list-map').removeClass('show-map-list');
            $('.list-wrap').removeClass('list-wrap-overflow');
        });

        // register paginate        
        $(document).on('click', '.pagination a[data-page]', e => {
            e.preventDefault();
            list.paginate(+$(e.currentTarget).attr('data-page'));
        });

        // more filters actions
        list.$moreFiltersBtns.on('click', list.toggleFilters);

        list.$moreFiltersContainer.find('.apply-filters').on('click', () => {
            
            // list.toggleFilters(false);
            list.$filtersForm.submit();

        });
        list.$moreFiltersContainer.find('.clear-filters').on('click', e => {
            let changed = false;
            let formData = {}
            $.map(list.params, (value, key) => {
                if (list.mainFields.indexOf(key) === -1) {
                    if (list.params[key] && list.params[key] != list.defaults[key]) {
                        changed = true;
                    }
                    formData[key] = list.defaults[key];
                }
            });
            list.setFormData(formData);

            list.toggleFilters(false);
            if (changed) {
                if (!e.target.classList.contains('clear-filters-mobile')) {
                    list.onChange();
                }
                if (!list.$body.length) {
                    list.$form.submit();
                }
            }
        });
        // show list item on map
        if (list.$list) {
            list.$list.on('click', '.show-on-map', e => {
                e.preventDefault();
                const $this = $(e.currentTarget);
                const publicId = +$this.attr('data-publicId');
                const marker = list.markers.filter(marker => marker.objectId === publicId)[0];
                list.suppressMapEvents = true;
                list.map.setCenter(marker.position);
                list.map.setZoom(15);
                list.infoWindowOpen = true;
                google.maps.event.trigger(marker, 'click');
            });
        }
        // mobile logic
        $('.form-trigger').on('click', () => {
            list.toggleMobileForm(true);
        });
        $('.form-close').on('click', () => {
            list.toggleMobileForm(false);
        });
        $('.map-trigger').on('click', list.toggleMobileMap);
    },
    setDisabledFields() {
        let disabledFields = list.$form.attr('data-disabledFields');
        if (disabledFields) {
            disabledFields = JSON.parse(disabledFields);
            $.map(disabledFields, (value, name) => {
                if (list.form[name]) {
                    list.disabledFields[name] = true;
                    list.defaults[name] = value;
                    list.form[name].disabled = true;
                    if (name == 'dateFrom' || name == 'dateTo') {
                        $(list.form[name]).next().prop('disabled', true);
                    }
                }
            });
        }
    },
    toggleFilters(toggle) {
        list.moreFilters = toggle === undefined ? !list.moreFilters : toggle;
        list.$moreFiltersBtns.toggleClass('active', list.moreFilters);
        list.$moreFiltersBtnsIcons.toggleClass('fa-chevron-up', list.moreFilters);
        list.$moreFiltersContainer.toggleClass('active', list.moreFilters);
    },
    toggleMobileForm(toggle) {
        if (toggle) {
            list.$body.addClass('modal-active');
            list.$formContainer.addClass('active');
        } else {
            list.$body.removeClass('modal-active');
            list.$formContainer.removeClass('active');
            list.toggleFilters(false);
        }
    },
    toggleMobileMap() {
        if (list.$body.hasClass('map-active')) {
            list.$body.removeClass('modal-active map-active');
        } else {
            list.$body.addClass('modal-active map-active');
            list.suppressMapEvents = true;
            list.cluster.fitMapToMarkers();
        }
    },
    setFiltersCount() {
        let filtersCount = 0;
        $.map(list.params, (val, name) => {
            if (name == 'dateTo' || name == 'sortBy') return;
            ((!functions.isMobile() && list.notCountabledFields.indexOf(name) === -1) || functions.isMobile()) && (val !== list.defaults[name] || list.disabledFields[name]) && val && (filtersCount++);
        });

        list.$filtersCount.html(filtersCount || '');
    },
    loadMap() {
        if ($('.list-map').length) {
            window.loadGoogleMaps();
            $(window).on('gMapsLoaded', list.initMap);
        }
    },
    initMap() {
        list.$map = $('.list-map');
        list.map = new google.maps.Map(list.$map[0], {
            zoom: 10,
            center: { lat: 45.12740978317192, lng: 13.902139984375038 },
            gestureHandling: 'greedy',
            mapTypeControl: false,
            styles: [{
                featureType: 'poi.business',
                elementType: 'labels',
                stylers: [
                    { visibility: 'off' }
                ]
            }]
        });
        // only trigger mapfind when zoomout or dragend, zoomin we already have data
        list.map.addListener('zoom_changed', () => {
            if (list.suppressMapEvents) {
                return;
            }
            list.cluster && list.cluster.clearMarkers();
            list.lastEvent = 'zoom';
        });
        list.map.addListener('dragend', () => {
            if (list.suppressMapEvents) {
                return;
            }
            list.cluster && list.cluster.clearMarkers();
            list.lastEvent = 'dragend';
        });
        list.map.addListener('bounds_changed', () => {
            if (list.suppressMapEvents) {
                setTimeout(() => {
                    list.suppressMapEvents = false;
                });
            }
        });
        list.map.addListener('idle', () => {
            if (list.suppressMapEvents) {
                return;
            }
            if (!list.lastEvent) {
                return;
            }

            const bounds = list.map.getBounds();
            const sw = bounds.getSouthWest();
            const nw = bounds.getNorthEast();
            list.params.coordinates = sw.lat() + ',' + nw.lat() + ',' + sw.lng() + ',' + nw.lng();
            list.params._page = 1;
            if(list.params.ms) {
                list.params.ms = '';
            }
            functions.setUrlData(list.params, true, false, list.defaults);
            // list.find();
        });

        // init info window
        list.infoWindow = new google.maps.InfoWindow({
            maxWidth: 300
        });
        list.infoWindow.addListener('domready', () => {
            // init infoWindow slider
            $('.map-info .list-item-slider').lightSlider({
                item: 1,
                mode: 'slide',
                pager: false,
                slideMargin: 0,
                loop: true,
                speed: 500,
                prevHtml: '<i class="fas fa-chevron-left"></i>',
                nextHtml: '<i class="fas fa-chevron-right"></i>'
            });
        });
    },
    setMarkers() {
        if (!list.map) {
            setTimeout(list.setMarkers, 50);
            return;
        }
        // init each marker
        list.markers = list.locations.map(location => {
            location.lat = +location.lat;
            location.lng = +location.lng;
            const marker = new google.maps.Marker({
                position: location,
                map: list.map,
                icon: {
                    path: google.maps.SymbolPath.CIRCLE,
                    scale: 10,
                    fillColor: "#AA0000",
                    fillOpacity: 0.6,
                    strokeWeight: 0
                },
            });
            marker.objectId = location.objectId;
            marker.addListener('click', () => {
                const params = {
                    objectId: marker.objectId,
                    dateFrom: list.params.dateFrom,
                    dateTo: list.params.dateTo,
                    persons: list.params.persons,
                    language: functions.getLang(),
                    template: 'map'
                };
                $.get('/services/details/', params).then(response => {
                    if (response.status) {
                        list.infoWindow.setContent(response.view);
                        list.infoWindow.setPosition({lat: marker.getPosition().lat(), lng: marker.getPosition().lng()});
                        list.infoWindow.open(list.map, marker);
                    }
                });
            });
            return marker;
        });
        // init cluster
        if (!list.cluster) {
            list.cluster = new MarkerClusterer(list.map, [], {
                gridSize: 100,
                minimumClusterSize: 3,
                maxZoom: 14,
                zoomOnClick: false,
                styles: [{
                    url: '/wp-content/uploads/images/cluster.png',
                    textSize: 14,
                    height: 40,
                    width: 40
                }]
            });
            // force cluster full zoom
            list.cluster.addListener('click', function(cluster) {
                list.map.setCenter(cluster.center_);
                list.map.setZoom(15);
            });
        }

        list.cluster.clearMarkers();
        list.cluster.addMarkers(list.markers);
        if (!list.lastEvent && !functions.smallWin()) {
            list.suppressMapEvents = true;
            if (list.markers.length === 1) {
                list.map.setCenter(list.markers[0].position);
                list.map.setZoom(13);
            } else {
                list.cluster.fitMapToMarkers();
            }
            return;
        }
        list.lastEvent = null;
    },
    setLoadingMode() {
        if (!list.loading) {
            list.loading = true;
            if (list.$listWrap.length) {
                $('.submit-loader-wrap').removeClass('d-none');
                list.$listWrap.addClass('loading').prepend(tplLoader);
                list.$listWrap.scrollTop(0); // mobile
                $('.list').scrollTop(0); 
                list.$list.scrollTop(0);
            } else {
                list.$form
                    .find('.form-submit').prop('disabled', true)
                    .find('i').addClass('fa-spinner fa-spin fa-lg');
            }
        }
    },
    unsetLoadingMode() {
        if (list.loading) {
            list.loading = false;
            $('.submit-loader-wrap').addClass('d-none');
            list.$listWrap.removeClass('loading').find('.list-loader').remove();
            list.$body.length && $('html, body').animate({ scrollTop: list.$body.offset().top }, 150);
        }
    },
    find() {
        // init list
        if (!list.$list) {
            list.$list = $('.list-items').length ? $('.list-items') : $('.list');
            list.list = list.$list[0];
        }
        list.setLoadingMode();

        let ajaxId = ++list.loadId;
        if (!list.pageOnlyChange || list.infoWindowOpen ) {
            list.mapFind(ajaxId);
            list.infoWindowOpen = false;
        }
        list.pageOnlyChange = false;
        let submitParams = $.extend({}, list.params);
        list.splitDates(submitParams);
        if (submitParams.template == 'compare')
        {
            let unitIds = JSON.parse(functions.getCookie("favorites")) || [];
            unitIds = unitIds.join(',');
            submitParams.unitIds = unitIds;
        }
        $.get('/services/list/', submitParams).then(response => {

            if (ajaxId !== list.loadId) {
                return;
            }
            response = JSON.parse(response);
            list.total = response.total;
            
            list.setResultsText();
            list.domInits();
            list.unsetLoadingMode();
            setTimeout(() => {
                list.$list[0].innerHTML = response.html;
            }, 200);
        });
    },
    setResultsText() {
        let maxResults = list.params._page * 10;
        list.$shownItems.html(
            (maxResults - 9) +
            ' - ' +
            (maxResults > list.total ? list.total : maxResults)
        );
        list.$total.html(list.total);
    },
    domInits() {
        // init tooltips
        list.$list.find('[data-toggle="tooltip"]').tooltip();

        // slider list item init
        setTimeout(() => {
            list.$list.find('.list-item-slider').lightSlider({
                item: 1,
                mode: 'slide',
                pager: false,
                slideMargin: 0,
                loop: true,
                speed: 500,
                prevHtml: '<i class="fas fa-chevron-left"></i>',
                nextHtml: '<i class="fas fa-chevron-right"></i>'
            });
            lozadObserver.observe();
            functions.initCompare();

            let $dropdown = $(".dropdown-sort-by");
        $dropdown.find('.dropdown-item').on('click', function (e) {
            e.preventDefault();
            list.params._page = 1;
            list.params.sortBy = $(e.currentTarget).attr('data-href');
            if ( list.$body.length ) {

                functions.setUrlData(list.params, true, false, list.defaults);
            } else {
                list.paginated = true;
                list.$form.submit();
            }
        });

        if (list.params.sortBy) {
            let text = $dropdown.find(".dropdown-item[data-href='"+list.params.sortBy+"']").html();
            $dropdown.find(".btn .sort-text").html(text);
        }

        }, 250);

        
         let compareItemsCount = $(".compare-list-item").length;

        if (compareItemsCount > 1)
        {
            $(".compare-list-items").lightSlider({
                item: 3,
                slideMargin: 0,
                pauseOnHover: true,
                loop: false,
                auto: false,
                pager: false,
                pause: 5000,
                speed: 500,
                enableDrag: false,
                prevHtml: '<span class="btn btn-dark btn-circle"><i class="las la-angle-left"></i></span>',
                nextHtml: '<span class="btn btn-dark btn-circle"><i class="las la-angle-right"></i></span>',
                responsive: [
                    {
                        breakpoint: 974,
                        settings: {
                            item: 1
                        }
                    }
                ]
            });

        }
    },
    mapFind(ajaxId) {
        let params = Object.assign({}, list.params);
        if (list.lastEvent) {
            const bounds = list.map.getBounds();
            const sw = bounds.getSouthWest();
            const nw = bounds.getNorthEast();
            params.coordinates = list.params.coordinates = sw.lat() + ',' + nw.lat() + ',' + sw.lng() + ',' + nw.lng();
        } else {
            if (!params.destination && !params.coordinates) {
                params.destination = '98:8';
            }
        }
        let submitParams = $.extend({}, params);
        list.splitDates(submitParams);
        $.get('/services/map/', submitParams).then(response => {
            if (ajaxId !== list.loadId) {
                return;
            }
            list.locations = JSON.parse(response);
            list.setMarkers();
        });
    },
    paginate(page) {
        if (page != list.params._page) {
            list.params._page = page;
        }
        if (list.$body.length) {
            list.pageOnlyChange = true;
            functions.setUrlData(list.params, list.$body.length);
        } else {
            list.paginated = true;
            list.$form.submit();
        }
    }
};

$(() => {
    list.init();
    list.loadMap();
});